module.exports = __webpack_public_path__ + "img/idea2_w.fded9bf8.svg";